<template>
    <div class="body-overlay" id="body-overlay"></div>
</template>

<script>
export default {
  name: "Overlay",
  
};
</script>


<style>

</style>


